// extracted by mini-css-extract-plugin
module.exports = {"BlogPostsCarousel":"styles_BlogPostsCarousel__6AXnQ","height":"styles_height__LCvjQ"};